import type { ChartExportProps } from '@/features/(charts)/chart-detail/hooks/use-chart-export';
import { exportMultiSeriesTableToExcel } from '@/features/(charts)/chart-renderer/lib/Cross/lib/exporter/exportMultiSeriesTableToExcel';
import useChartCrossTableData from '@/features/(charts)/chart-renderer/ui/Cross/useChartCrossTableData.v2';

export const useMultiSeriesExport = (
  props: ChartExportProps & { enabled: boolean },
) => {
  const { chartBase, tableData, title, enabled } = props;

  const { columns, dataSource } = useChartCrossTableData({
    chart: {
      ...chartBase,
      name: title || '',
    },
    tableData: enabled
      ? (tableData as ChartCrossTableRes)
      : {
          tables: [],
          field_item_meta: [],
          compare_tables: [],
        },
    enabled,
  });

  const handleMultiSeriesExport = () => {
    if (!enabled) return;
    // chart 이름을 파일명으로 사용
    const filename = `${title}_${new Date().toJSON().split('T')[0]}.xlsx`;
    exportMultiSeriesTableToExcel(columns, dataSource, filename);
  };

  return handleMultiSeriesExport;
};
